
import {
  defineComponent, reactive, onBeforeMount,
} from 'vue';
import { IColumn } from '@/core/models/AntDesign/IColumn';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import Card from '@/core/components/Tela/Card.vue';
import BuscaRapida from '@/core/components/BuscaRapida.vue';
import Icone from '@/core/components/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useTelaBase } from '@/core/composables/TelaBase';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import { EStatusPedidoCompra } from '@/models/Enumeradores/Compras/EStatusPedidoCompra';
import { IDTOPedidoCompra } from '@/models/DTO/Compras/IDTOPedidoCompra';
import ServicoPedidoCompra from '@/servicos/Compras/ServicoPedidoCompras';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { IParametrosConsultaRecebimentoMercadoria } from '@/models/ParametrosRequisicao/Compras/IParametrosConsultaRecebimentoMercadoria';
import { ECondicao } from '@/core/models/Enumeradores/ECondicao';
import { ETipoDado } from '@/core/models/Enumeradores/ETipoDado';

export default defineComponent({
  name: 'RecebimentoMercadoriasPedidoCompra',
  props: {
    empresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    Icone,
    BuscaRapida,
    SelecionarFiltroPeriodoMovimentoComercial,
    MensagemSemDados,
    SelecionarDataInicialFinal,
  },
  emits: ['importarNfe'],
  setup(props, { emit }) {
    const servicoPedidoCompra = new ServicoPedidoCompra();
    servicoPedidoCompra.requisicaoSistema();

    const { apresentarMensagemAlerta } = useTelaBase();

    const state = reactive({
      valorBusca: '',
      filtroPeriodo: {} as EFiltroPeriodoMovimentoComercial,
      status: {} as EStatusPedidoCompra,
      buscandoPedidos: false,
      pedidos: [] as IDTOPedidoCompra[],
      telaMobile: false,
      importando: false,
      colunasGrade: [] as IColumn[],
      dataInicial: '',
      dataFinal: '',
    });

    const radioStyle = reactive({
      display: 'flex',
      height: '30px',
      lineHeight: '30px',
    });

    state.filtroPeriodo = EFiltroPeriodoMovimentoComercial.Ultimos30Dias;
    state.status = EStatusPedidoCompra.Confirmado;

    async function importarPedido(codigoPedido: number) {
      if (UtilitarioGeral.validaCodigo(codigoPedido)) {
        const recebimento = await servicoPedidoCompra.importarPedidoCompra(codigoPedido, props.empresa);
        if (UtilitarioGeral.objetoValido(recebimento)) {
          recebimento.codigoPedido = codigoPedido;
          emit('importarNfe', recebimento);
          return;
        }
      }
      apresentarMensagemAlerta('Não foi possível importar o pedido de compra!');
    }

    function preencherColunas() {
      if (state.telaMobile) {
        state.colunasGrade = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'Número Pedido', dataIndex: 'item', key: 'Item', position: 2, visible: true, ellipsis: true,
          },
        ];
      } else {
        state.colunasGrade = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 0, visible: false,
          },
          {
            title: 'Fornecedor', dataIndex: 'fornecedor', key: 'Fornecedor', position: 1, visible: true, width: 150, align: 'left', ellipsis: true,
          },
          {
            title: 'Número', dataIndex: 'numeroPedido', key: 'NumeroPedido', position: 2, visible: true, width: 50, ordering: false, align: 'right', ellipsis: true,
          },
          {
            title: 'Data Criação', dataIndex: 'dataCriacao', key: 'DataCriacao', position: 3, visible: true, ordering: false, align: 'center', width: 75, ellipsis: true,
          },
          {
            title: 'Data Previsão Entrega', dataIndex: 'dataPrevisaoEntrega', key: 'DataPrevisaoEntrega', position: 4, visible: true, ordering: false, align: 'right', width: 75, ellipsis: true,
          },
          {
            title: 'Valor R$', dataIndex: 'totalPedido', key: 'TotalPedido', position: 5, visible: true, ordering: false, align: 'right', width: 75, ellipsis: true,
          },
          {
            title: 'Ações', key: 'acoes', position: 6, visible: true, width: 50, align: 'center', ellipsis: true,
          },
        ];
      }
    }

    async function buscarPedidos() {
      state.buscandoPedidos = true;
      state.pedidos = [];
      const filtros = [] as IFiltroGenerico[];
      const filtro = {} as IFiltroGenerico;

      filtro.apresentacao = 'Status';
      filtro.identificador = 'Status';
      filtro.condicao = ECondicao.Igual;
      filtro.tipoDado = ETipoDado.Numerico;
      filtro.valores = ['3'];

      filtros.push(filtro);

      const parametrosConsulta = {} as IParametrosConsultaRecebimentoMercadoria;
      parametrosConsulta.empresas = [props.empresa];
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.periodo = state.filtroPeriodo;
      parametrosConsulta.dataInicial = state.dataInicial;
      parametrosConsulta.dataFinal = state.dataFinal;
      parametrosConsulta.valorBuscaRapida = state.valorBusca;
      parametrosConsulta.ordenacao.push('Codigo', 'Ordem');

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      const listaPaginada = await servicoPedidoCompra.buscaAvancada(parametrosConsulta, filtros);
      state.pedidos = listaPaginada.dados;
      state.buscandoPedidos = false;
    }

    onBeforeMount(async () => {
      preencherColunas();
      await buscarPedidos();
    });

    return {
      props,
      state,
      UtilitarioMascara,
      UtilitarioData,
      importarPedido,
      buscarPedidos,
      radioStyle,
      EFiltroPeriodoMovimentoComercial,
    };
  },
});
